const Login = {
    // 登录和找回密码/反馈
    'login_请输入用户名或手机号码': {
      cn: '请输入用户名/手机号码/邮箱',
      en: 'User name/Mobile number/Email'
    },
    'login_请输入登录密码': { cn: '请输入登录密码', en: 'Login password', kr: '' },
    'login_请输入客户代码': { cn: '请输入客户代码', en: 'Client code' },
    'login_接口名称': { cn: '接口名称', en: 'Interface name' },
    'login_描述': { cn: '描述', en: 'describe' },
    'login_收费': { cn: '收费', en: 'Charge' },
    'login_免费': { cn: '免费', en: 'Free' },
    'login_登录中': { cn: '登录中', en: 'Logging in' },
    'login_ERP1.0客户登录': { cn: 'ERP1.0客户登录', en: 'ERP1.0 customer login' },
    'login_请输入右侧验证码': { cn: '请输入右侧验证码', en: 'Please enter the right verification code' },
    'login_恭喜您注册成功': { cn: '恭喜您注册成功', en: 'Congratulations on your successful registration' },
    'login_请妥善保管您的账户信息': { cn: '请妥善保管您的账户信息', en: 'Please keep your account information' },
    'login_进入首页': { cn: '进入首页', en: 'Enter the home page' },
    'login_进入工作台': { cn: '进入工作台', en: 'Enter the workbench' },
    'login_手机号找回': { cn: '手机号找回', en: 'By Mobile' },
    'login_重置登录密码': { cn: '重置登录密码', en: 'Reset login password' },
    'login_请再次输入登录密码': { cn: '请再次输入登录密码', en: 'Please enter a password again' }
  }
  const feedBack = {
    'feedBack_请输入电话号码': { cn: '请输入电话号码', en: 'Please enter the phone number' },
    'feedBack_请输入公司名称': { cn: '请输入公司名称', en: 'Please enter company name' },
    'feedBack_公司区域': { cn: '公司区域', en: 'Company area' },
    'feedBack_选填，其他内容可在备注中': { cn: '选填，其他内容可在备注中', en: 'Optional' },
    'feedBack_预约': { cn: '预约', en: 'Make an appointment' },
    'feedBack_姓名不能为空': { cn: '姓名不能为空', en: 'Name cannot be empty' },
    'feedBack_电话不能为空': { cn: '电话不能为空', en: 'Mobile must not be empty' },
    'feedBack_邮箱不能为空': { cn: '邮箱不能为空', en: 'Email cannot be empty' },
    'feedBack_区域不能为空': { cn: '区域不能为空', en: 'Region cannot be empty' },
    'feedBack_公司不能为空': { cn: '公司不能为空', en: 'Company cannot be empty' },
    'feedBack_专人在线演示解答': { cn: '专人在线演示解答', en: 'Online answer in Demo' },
    'feedBack_快速了解产品功能使用': { cn: '快速了解产品功能使用', en: 'Quickly understand product features to use' },
    'feedBack_提供专属解决方案': { cn: '提供专属解决方案', en: 'Provide exclusive solution' },
    'feedBack_业务专家将会尽快联系您': { cn: '业务专家将会尽快联系您', en: 'The business expert will contact you to see appointment as soon as possible' }
  }

  export default {
    ...Login,
    ...feedBack
  }
